// Légende de la liste des étudiants (fiche réception) : 1 gris, 2 jaune, 3 orange, 4 bleu, 5 rouge, 6 noir.
export const WARNING_LEVELS = [
  { level: 1, label: 'Avertissement verbal GK', badge: 'bg-zinc-400 text-black', ring: 'ring-zinc-400' },
  { level: 2, label: 'Avertissement écrit Direction', badge: 'bg-yellow-400 text-black', ring: 'ring-yellow-400' },
  { level: 3, label: 'Avert. écrit + Travail d\'intérêt', badge: 'bg-orange-500 text-black', ring: 'ring-orange-500' },
  { level: 4, label: 'Avert. écrit + expulsion temporaire', badge: 'bg-blue-500 text-white', ring: 'ring-blue-500' },
  { level: 5, label: 'Convoqué au conseil disciplinaire', badge: 'bg-red-600 text-white', ring: 'ring-red-600' },
  { level: 6, label: 'Avert. écrit + expulsion définitive', badge: 'bg-black text-white border border-white/70', ring: 'ring-white' },
];

export function warningInfo(level) {
  return WARNING_LEVELS.find((item) => item.level === Number(level)) || null;
}
